import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/database';

export default function StatusPage() {
  const { t } = useTranslation();
  const member = useStore(s => s.getMember());
  const status = member?.status || 'waitlist';

  return (
    <div className="min-h-dvh bg-ivory flex flex-col items-center justify-center px-6">
      <div className="text-center space-y-6 max-w-sm">
        <h1 className="font-serif text-3xl tracking-widest-xl">AH</h1>
        <div className="w-12 h-px bg-gold mx-auto" />
        <p className="text-sm font-sans text-charcoal/70 leading-relaxed">
          {t(`status.${status}`)}
        </p>
        <p className="text-[11px] font-sans text-charcoal/40">{t('status.contact')}</p>
        <Link to="/login" className="inline-block text-[11px] tracking-widest uppercase font-sans text-charcoal/40 hover:text-charcoal transition-colors border-b border-charcoal/15 pb-0.5">
          {t('auth.enterHouse')}
        </Link>
      </div>
    </div>
  );
}
